import { render } from "./agentUserManage.vue?vue&type=template&id=0652bcfe"
import script from "./agentUserManage.vue?vue&type=script&lang=js"
export * from "./agentUserManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__